export const expenselist = [
  {
    id: "1",
    categoryName: "Employee Benefits",
    reference: "EX001",
    date: "19 Jan 2023",
    status: "Approved",
    amount: "$550",
    description: "Employee Vehicle",
    action: "",
  },
  {
    id: "2",
    categoryName: "Foods & Snacks",
    reference: "EX002",
    date: "27 Jan 2023",
    status: "Approved",
    amount: "$570",
    description: "Employee Foods",
    action: "",
  },
  {
    id: "3",
    categoryName: "Entertainment",
    reference: "EX003",
    date: "03 Feb 2023",
    status: "Approved",
    amount: "$400",
    description: "Office Vehicle",
    action: "",
  },
  {
    id: "4",
    categoryName: "Office Expenses & Postage",
    reference: "EX004",
    date: "17 Feb 2023",
    status: "Pending",
    amount: "$750",
    description: "Employee Foods",
    action: "",
  },
  {
    id: "5",
    categoryName: "Employee Benefits",
    reference: "EX005",
    date: "14 Mar 2023",
    status: "Pending",
    amount: "$470",
    description: "Employee Vehicle",
    action: "",
  },
  {
    id: "6",
    categoryName: "Foods & Snacks",
    reference: "EX006",
    date: "28 Mar 2023",
    status: "Approved",
    amount: "$200",
    description: "Employee Foods",
    action: "",
  },
  {
    id: "7",
    categoryName: "Entertainment",
    reference: "EX007",
    date: "06 Apr 2023",
    status: "Pending",
    amount: "$380",
    description: "Office Vehicle",
    action: "",
  },
  {
    id: "8",
    categoryName: "Office Expenses & Postage",
    reference: "EX008",
    date: "19 Apr 2023",
    status: "Approved",
    amount: "$620",
    description: "Employee Foods",
    action: "",
  },
  {
    id: "9",
    categoryName: "Employee Benefits",
    reference: "EX009",
    date: "08 May 2023",
    status: "Pending",
    amount: "$430",
    description: "Employee Vehicle",
    action: "",
  },
  {
    id: "10",
    categoryName: "Foods & Snacks",
    reference: "EX010",
    date: "23 May 2023",
    status: "Approved",
    amount: "$120",
    description: "Employee Foods",
    action: "",
  },
  {
    id: "11",
    categoryName: "Entertainment",
    reference: "EX011",
    date: "24 Nov 2023",
    status: "Pending",
    amount: "$620",
    description: "Office Vehicle",
    action: "",
  },
  {
    id: "12",
    categoryName: "Office Expenses & Postage",
    reference: "EX012",
    date: "19 Nov 2023",
    status: "Approved",
    amount: "$430",
    description: "Employee Foods",
    action: "",
  },
];
